import { useEffect } from 'react';

const useAutoScrollOnFocus = (): void => {
    useEffect(() => {
        if (!__isBrowser__ || typeof document === 'undefined' || typeof window === 'undefined') {
            return;
        }

        const handleFocus = (event: FocusEvent): void => {
            const input = event.target as HTMLElement | null;
            if (!input) {
                return;
            }

            const initialScreenSize = window.innerHeight;
            const viewportHeight = window.visualViewport?.height ?? initialScreenSize;
            const isKeyboardOpened = viewportHeight < initialScreenSize;

            if (isKeyboardOpened) {
                input.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        };

        const inputs = Array.from(document.querySelectorAll<HTMLElement>('input, textarea'));
        inputs.forEach((input) => input.addEventListener('focus', handleFocus));

        return () => {
            inputs.forEach((input) => input.removeEventListener('focus', handleFocus));
        };
    }, []);
};

export default useAutoScrollOnFocus;
